<template>
  <div>
    <tk-flex  between >
      <public-header v-if="pageData && pageData.objectId" :title="pageData.headline" show-back></public-header>
    </tk-flex>
    <a-spin :spinning="loading" class="full-width" style="min-height: 60vh;" >
      <div style="display: none;">.</div>
      <div class="full-width bg-white border-radius-12" v-if="pageData && pageData.objectId" >
        <Layout :showMenu="true" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="false"  >
          <template slot="content" >
            <div class="font-14 font-bold m-b-20" style="color: #363B45" v-if="key !== 2">{{ menuList[key].name }}</div>
            <div v-show="key === 0" style="height:100%">
              <a-row :gutter="[20,20]" class="font-12" style="color: #363B45" >
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  类型：{{ pageData.type === '0' ? '地区' : '全国' }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.type === '0'">
                  <a-tooltip>
                    <template slot="title">
                      {{agentList}}
                    </template>
                    代理商：代理商({{pageData.agent.length}})
                  </a-tooltip>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  活动开始时间：{{ pageData.startDate | date }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  活动结束时间：{{ pageData.endDate | date }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  是否开启：{{ pageData.isClose ? '否' : '是' }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  公示天数：{{ pageData.publicityDays }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.popupPicture">
                  <tk-flex>
                    弹出图片：
                    <viewer v-if="pageData.popupPicture" :images="[pageData.popupPicture]">
                      <img :src="pageData.popupPicture" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;object-fit: contain;" />
                    </viewer>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.detailPicture">
                  <tk-flex>
                    活动详情图：
                    <viewer v-if="pageData.detailPicture" :images="[pageData.detailPicture]">
                      <img :src="pageData.detailPicture" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;object-fit: contain;" />
                    </viewer>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
                  <tk-flex>
                    <div class="unshrink">活动规则：</div>
                    <div v-html="pageData.details" class="p-15" style="height: 450px; width: 100%;overflow-y: scroll;border-radius: 6px;border: 1px solid #DBDDE1;" ></div>
                  </tk-flex>
                </a-col>
              </a-row>
            </div>
            <div v-if="key === 1" style="height:100%">
              <ak-model-table v-if="id" style="width:100%" model="stackheadRecord"  :perPage="20" :filters="filters" tableSize="small"/>
            </div>
            <div v-if="key === 2" style="height:100%">
              <tk-flex between style="paddingBottom: 14px">
                <div style="color: #363B45;font-weight: 700;font-size: 14px;">达标名单</div>
                <a-button type="primary" @click="showCreateQualified= true">
                  新建
                </a-button>
              </tk-flex>
              <ak-model-table v-if="id" style="width:100%" model="stackheadQualified"  ref="qualifiedList" :perPage="20" :filters="{...filters, isQualified: true}" tableSize="small"/>
            </div>
          </template>
        </Layout>
      </div>
    </a-spin>
    <created-qualified v-if="showCreateQualified" :id="id" @complete="qualifiedComplete"></created-qualified>
  </div>
</template>
<script>
import Layout from '../../components/layout.vue'
import publicHeader from '../../../components/publicHeader.vue'
import createdQualified from '../../../core/component/stackhead/createdQualified.vue'
export default {
  components: {
    publicHeader,
    Layout,
    createdQualified
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      menuList: [
        {
          name: '基本信息'
        }
      ],
      filters: {},
      key: 0,
      id: null,
      showCreateQualified: false,
      agentList: ''
    }
  },
  // 监听页面id的变化
  watch: {
    $route (to, from) {
      this.init()
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        this.menuList = [
          {
            name: '基本信息'
          }
        ]
        this.filters.marketingCampaign = this.id
        if (this.$store.state.user.level === '4' || this.$store.state.user.level === '3') {
          // 增加一个查询条件，仅查询激活的用户
          let id = this.$store.state.user.objectId
          if (this.$store.state.user.level === '4') {
            id = this.$store.state.user.agent
          }
          this.filters.agent = id
        }
        if (this.$store.state.user.level === '1') {
        // 战区
          this.filters.warZone = this.$store.state.user.department
        }
        if (this.$store.state.user.level === '2') {
        // 大区
          this.filters.regional = this.$store.state.user.department
        }
        await this.getData()
        if (this.can('reviewStackheadRecord')) {
          this.menuList.push({ name: '参加门店' })
        }
        if (this.can('uploadStackheadActivity')) {
          this.menuList.push({ name: '达标名单' })
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    // 获取数据
    async getData () {
      const { data } = await this.$tkParse.get(`/classes/marketingCampaign/${this.$route.query.id}`, {
        params: { include: 'series,voltage,capacity,gift' }
      })
      console.log(data)
      data.details = data.details.replace(/<img/g, '<img style="max-width:100%;height:auto"')
      this.pageData = data
      if (data.type === '0') {
        let { data: user } = await this.$tkParse.get(`/classes/_User`, {
          params: {
            keys: 'nickName',
            limit: data.agent.length,
            where: {
              objectId: {
                $in: data.agent
              }
            }
          }
        })
        let arr = user.results.map(item => {
          return item.nickName
        })
        this.agentList = arr.join('、')
      }
    },
    // 刷新商品
    refresh () {
      this.getData()
    },
    qualifiedComplete (type) {
      this.showCreateQualified = false
      if (type === 'refresh') {
        this.$refs.qualifiedList.refresh()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
